'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dbChange = exports.typeLoadWatch = exports.typeListener = exports.typeLoader = exports.handleChanged = exports.handleInit = exports.loginUser = undefined;

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.handleAuth = handleAuth;
exports.dbChanges = dbChanges;

var _reduxGraph = require('redux-graph');

var _capeReduxReducer = require('cape-redux-reducer');

var _capeReduxAuth = require('cape-redux-auth');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginUser = exports.loginUser = (0, _curry3.default)(function (firebase, _ref, user) {
  var dispatch = _ref.dispatch;

  // console.log(pickBy(user, isString))
  var entity = (0, _util.userEntity)(user);
  dispatch((0, _capeReduxAuth.login)((0, _util.authUsr)(entity)));
  // entitySet(firebase, { ...entity, type: 'GoogleUser' })
  dispatch((0, _reduxGraph.entityPut)(_extends({}, entity, { type: 'GoogleUser' })));
  return (0, _util.getDbEntity)(firebase, entity).then(function (dbEntity) {
    if (!dbEntity) return (0, _util.entitySet)(firebase, entity);
    return null;
  });
});

function handleAuth(firebase, store, fireUser) {
  var dispatch = store.dispatch,
      getState = store.getState;

  if (fireUser) {
    if (fireUser.isAnonymous) {
      // Save to redux a person entity.
      dispatch((0, _reduxGraph.entityPut)({ type: 'Person', id: fireUser.uid }));
      return dispatch((0, _capeReduxAuth.setUserId)(fireUser.uid));
    }
    return loginUser(firebase, store, fireUser);
  }
  if ((0, _capeReduxAuth.isAuthenticated)(getState())) return dispatch((0, _capeReduxAuth.logout)());
  // Create anon session?
  if (firebase.doSignInAnon) return firebase.auth.signInAnonymously();
  return null;
}

var handleInit = exports.handleInit = (0, _curry3.default)(function (_ref2, type, result) {
  var dispatch = _ref2.dispatch;

  var payload = (0, _map3.default)(result, (0, _util.ensureIdType)(type));
  if ((0, _isEmpty3.default)(payload)) return null;
  return dispatch({ type: _reduxGraph.ENTITY_PUTALL, payload: payload, meta: { sendSocket: false } });
});
var handleChanged = exports.handleChanged = (0, _curry3.default)(function (_ref3, typeId, change, key) {
  var dispatch = _ref3.dispatch,
      getState = _ref3.getState;

  var newVal = (0, _util.ensureIdType)(typeId, change, key);
  var oldVal = (0, _reduxGraph.getEntity)(getState(), newVal);
  if (oldVal && newVal.dateModified === oldVal.dateModified) return null;
  return dispatch({ type: _reduxGraph.ENTITY_PUT, payload: newVal, meta: { source: 'firebase' } });
});
var typeLoader = exports.typeLoader = (0, _curry3.default)(function (_ref4, store, typeId) {
  var entity = _ref4.entity;
  return (0, _util.getChild)(entity, typeId).then(handleInit(store, typeId));
});
var typeListener = exports.typeListener = (0, _curry3.default)(function (_ref5, store, typeId) {
  var entity = _ref5.entity;
  return (0, _util.onChildChanged)(entity, typeId, handleChanged(store, typeId));
});
// Load init state and then listen for changes.
var typeLoadWatch = exports.typeLoadWatch = (0, _curry3.default)(function (firebase, store, typeId) {
  return Promise.all([typeLoader(firebase, store, typeId), typeListener(firebase, store, typeId)]);
});
var dbChange = exports.dbChange = (0, _curry3.default)(function (_ref6, result) {
  var dispatch = _ref6.dispatch;
  return dispatch((0, _capeReduxReducer.replaceDb)(result));
});
function dbChanges(_ref7, store) {
  var db = _ref7.db;

  return (0, _util.getWatchChild)(db, 'db', dbChange(store));
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/~/cape-firebase/lib/handler.js
// module id = 363
// module chunks = 0